/* eslint-disable @typescript-eslint/no-explicit-any */
import { Collapse } from "@mui/material";
import ProductStock from "../ProductStock";
import useCustomMemo from "../../GenericComponents/useCustomMemo";

type ShowInformationAboutOneVariantProps = {
  variant: any;
  showMore: boolean;
  index: number;
  changeOneVariant: (index: number, variant: any) => void;
};
export default function ShowInformationAboutOneVariant(
  props: ShowInformationAboutOneVariantProps
) {
  const { variant, showMore, index, changeOneVariant } = props;
  const cache = useCustomMemo();
  const inventoriesFromCache = cache.inventories || [];

  return (
    <Collapse
      in={showMore}
      style={{
        backgroundColor: "#f3f3f3",
        padding: "10px 20px 0px 20px",
        borderRadius: 5,
        marginBottom: showMore ? 10 : 0,
      }}
    >
      <ProductStock
        allInventoriesForAutocomplete={inventoriesFromCache}
        inventories={variant.inventories || []}
        handleChangeInventories={(inventories) => {
          const newVariant = structuredClone(variant);
          inventories.forEach((inventory: any) => {
            inventory.quantity = +inventory.quantity || 0;
            inventory.price = +inventory.price || 0;
          });
          newVariant.inventories = inventories;
          changeOneVariant(index, newVariant);
        }}
      />
    </Collapse>
  );
}
